import { useCallback } from 'react';
import { useReactFlow, useUpdateNodeInternals } from '@xyflow/react';
import { isNodeOutOfViewport } from '../Components/Calculations/utils';
import { flowNode } from '../Components/Calculations/CalculationCanvas/CalculationCanvas';
// First RAF: ensure node internals update
// Second RAF: wait for DOM layout to stabilize before measuring
export const useEnsureNodeVisible = () => {
  const { getNode, getViewport, fitBounds } = useReactFlow();
  const updateNodeInternals = useUpdateNodeInternals();

  const ensureNodeVisible = useCallback(
    (nodeId: string, _toFocus?: boolean | undefined) => {
      if (!nodeId) return;

      requestAnimationFrame(() => {
        updateNodeInternals(nodeId);

        requestAnimationFrame(() => {
          const node = getNode(nodeId) as flowNode | undefined;
          if (!node) return;
          const width = node.measured?.width ?? 0;
          const height = node.measured?.height ?? 0;
          const viewport = getViewport();
          const containerRect = node.data.parentRect;
          if (!containerRect) return;
          let isOut = true;
          if (!_toFocus) {
            isOut = isNodeOutOfViewport(node, viewport, containerRect.width, containerRect.height);
          }

          // console.log("view check", isOut)
          if (isOut || _toFocus) {
            fitBounds(
              {
                x: node.position.x,
                y: node.position.y,
                width,
                height,
              },
              {
                padding: _toFocus && height < 250 ? 0.8 : height < 250 ? 0.6 : 0.3,
                duration: 200,
              },
            );
            // console.log("view fit")
          }
        });
      });
    },
    [getNode, getViewport, updateNodeInternals],
  );

  return ensureNodeVisible;
};
